import { createApp } from 'vue'

import App from './App'
import router from "@/router";
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
// import * as labsComponents from 'vuetify/labs/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
// import { VDatePicker } from 'vuetify/labs/VDatePicker'
// import {Sortable, Swap} from "sortablejs/modular/sortable.core.esm";
// Sortable.mount(new Swap());
import '@vuepic/vue-datepicker/dist/main.css';
import PrimeVue from 'primevue/config';
import axios from "axios";

axios.defaults.baseURL = 'https://api.sama11112323333.shop/';//'http://54.36.25.161:8001/';   - prod           'http://127.0.0.1:8001/' - loc  https://api.sama11112323333.shop/

const vuetify = createVuetify({
  components,
  directives,
})

// const { createApp, provide, inject, computed } = Vue;

createApp(App)
    .use(router)
    .use(vuetify)
    .use(PrimeVue)
    .mount('#app');

// app.component('VueDatePicker', VueDatePicker)

